/**
 * One face of the Practice Arena card's rotating flashcard stack.
 *
 * Decorative: this is the dashboard's illustration of what practice looks like,
 * not a real card from the user's deck. The content it renders comes from three
 * hard-coded placeholder concepts in `PracticeArenaCard` — the real runner is
 * `features/mindspace/practice/runners/FlashcardRunner`.
 *
 * `isFront` picks the face. The question side asks, the answer side answers,
 * and the stack alternates them so six faces read as three cards.
 */

interface FlashcardContentProps {
  title: string;
  description?: string;
  /** Question face when true, answer face when false. */
  isFront?: boolean;
}

export function FlashcardContent({
  title,
  description,
  isFront = true,
}: FlashcardContentProps) {
  return (
    <div className='flex h-full flex-col p-4'>
      <div className='mb-2 text-xs font-medium text-muted-foreground'>
        {isFront ? 'Question' : 'Answer'}
      </div>

      <div className='flex flex-1 items-center justify-center'>
        {isFront ? (
          <p className='text-center text-sm font-semibold text-foreground'>
            What is {title}?
          </p>
        ) : (
          <p className='line-clamp-4 text-center text-xs leading-relaxed text-muted-foreground'>
            {description || 'No description available'}
          </p>
        )}
      </div>
    </div>
  );
}
